// API related actions
export const SUBMIT_EXECUTE_MONTH_CLOSE_REQUEST = '@@toyota/SUBMIT_EXECUTE_MONTH_CLOSE_REQUEST';
export const SUBMIT_EXECUTE_MONTH_CLOSE_SUCCESS = '@@toyota/SUBMIT_EXECUTE_MONTH_CLOSE_SUCCESS';
export const SUBMIT_EXECUTE_MONTH_CLOSE_FAILED = '@@toyota/SUBMIT_EXECUTE_MONTH_CLOSE_FAILED';
export const FETCHING_MONTH_CLOSE_REPORT = '@@toyota/FETCHING_MONTH_CLOSE_REPORT';
export const FETCHED_MONTH_CLOSE_REPORT = '@@toyota/FETCHED_MONTH_CLOSE_REPORT';
export const FETCHED_MONTH_CLOSE_REPORT_FAILED = '@@toyota/FETCHED_MONTH_CLOSE_REPORT_FAILED';
export const DELETE_MONTH_CLOSE_REPORT = '@@toyota/DELETE_MONTH_CLOSE_REPORT';
export const CHANGE_MONTH_CLOSE_REPORT_LIST_PAGE = '@@toyota/CHANGE_MONTH_CLOSE_REPORT_LIST_PAGE';
export const CHANGE_MONTH_CLOSE_REPORT_LIST_PAGE_SIZE = '@@toyota/CHANGE_MONTH_CLOSE_REPORT_LIST_PAGE_SIZE';
export const DOWNLOADING_MONTH_CLOSE_REPORT_LIST_FILE = '@@toyota/DOWNLOADING_MONTH_CLOSE_REPORT_LIST_FILE';
export const DOWNLOADED_MONTH_CLOSE_REPORT_LIST_FILE = '@@toyota/DOWNLOADED_MONTH_CLOSE_REPORT_LIST_FILE';
export const DOWNLOADED_MONTH_CLOSE_REPORT_LIST_FILE_FAILED = '@@toyota/DOWNLOADED_MONTH_CLOSE_REPORT_LIST_FILE_FAILED';
export const DELETE_URL = '@@toyota/DELETE_URL';
